export enum StudentListMode {
  BY_CLASS = "by_class",
  ALL_STUDENTS = "all_students",
  NEEDS_ATTENTION = "needs_attention",
  TOP_PERFORMERS = "top_performers"
}

export type GetChildrenStatsResponseTypes = ChildStatsTypes[][];

export type ChildStatsTypes = {
  childId: number;
  childName: string;
  childClass?: string;
  childProfileImageUrl: string;
  dashboardReadingLevelResponse: {
    maxReadingLevel: number;
    currentReadingLevel: number;
  };
  dashboardReadingMinutesResponse: {
    currentReadingMinutes: number;
    targetReadingMinutes: number;
    readingMinutesCompletionPercent: number;
    previousReadingMinutes: number;
    readingMinutesIncrease: number;
    maxReadingMinutes: number;
  };
  dashboardReadingSpeedResponse: {
    maxReadingSpeed: number;
    currentReadingSpeed: number;
    readingSpeedCompletionPercent: number;
    previousReadingSpeed: number;
    readingSpeedIncrease: number;
  };
  dashboardReadingScheduleAdherenceResponse: {
    maxAdherence: number;
    currentReadingDays: number;
    targetReadingDays: number;
    scheduleAdherencePercent: number;
    previousReadingDays: number;
  };
  currentWeeksStreakModel: {
    streak: number;
  };
  vocabulary?: number;
  fluencyRate?: number;
  pronunciationRate?: number;
};

export type GetStudentStatsRequestTypes = {
  id: number;
  groupType?: number;
  groupId?: number;
  searchPhrase?: string;
  userId?: number;
};

export type GetClassDetailsPerUserRequestTypes = {
  id: number;
  groupId?: number;
  reportType: number;
  startDate: string;
  endDate: string;
};

export type GetClassDetailsByDateRequestTypes = {
  id: number;
  groupId?: number;
  reportType: number;
  startDate: string;
  endDate: string;
  groupBy: number;
};

export type StudentStatsItemTypes = {
  userId: number;
  name: string;
  roleId?: string;
  profileImageUrl?: string;
  progressMetrics?: StudentProgressMetricTypes[];
};

export type GetStudentStatsResponseTypes = StudentStatsItemTypes[];

export type MemberItemStatsTypes = {
  userId: number;
  name: string;
  roleId: number;
  profileImageUrl: string;
};

export type GetClassDetailsPerUserResponseTypes = ClassDetailsUserTypes[];

export type ClassDetailsUserTypes = {
  rank: number;
  id: string;
  name: string;
  value: number;
};

export type GetClassDetailsByDateResponseTypes = ClassDetailsByDateTypes[];

export type ClassDetailsByDateTypes = {
  date: string;
  value: number;
};

export type ClassItemStatsTypes = {
  groupId: number;
  groupName: string;
  members?: MemberItemStatsTypes[];
};

export type GetClassListStatsResponseTypes = ClassItemStatsTypes[];

export type GetClassListStatsRequestTypes = {
  id: number;
  groupType?: number;
  groupTypeId?: number;
  searchPhrase?: string;
  userId?: number;
};

export type GetClassItemStatsRequestTypes = {
  id: number;
  groupId?: number;
};

export type StudentItemStatsTypes = {
  userId: number;
  name: string;
  profileImageUrl?: string;
  readingLevel: number;
  vocabulary: number;
  fluencyRate: number;
  pronunciationRate: number;
};

export type GetClassItemStatsResponseTypes = {
  groupId: number;
  averageReadingLevel: number;
  vocabulary: number;
  fluencyRate: number;
  pronunciationRate: number;
  readingLevelLowerBound: number;
  readingLevelUpperBound: number;
  vocabularyLowerBound: number;
  vocabularyUpperBound: number;
  fluencyRateLowerBound: number;
  fluencyRateUpperBound: number;
  pronunciationRateLowerBound: number;
  pronunciationRateUpperBound: number;
  students: StudentItemStatsTypes[];
};

export type GetStudentProgressRequestTypes = {
  userId: number;
  languageId: number;
};

export type StudentProgressMetricTypes = {
  assessmentMetricId: number;
  assessmentCategoryId: number;
  assessmentCategory: string;
  assessmentMetric: string;
  value: number;
};

export type GetStudentProgressResponseTypes = {
  metrics: StudentProgressMetricTypes[];
};

export type GetPowerBiConfigResponseTypes = {
  token: string;
  tokenId: string;
};
